module.exports = __webpack_public_path__ + "img/HDFC_Life.5faa969d.png";